export const environment = {
  production: true,
  api_url: 'https://creative-api.inprice.com.br',
  jwt_domain: 'creative-api.inprice.com.br'
};
